<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>
  <div *ngFor=" let item of data.name" class="error_msg">
{{item}}
</div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" [mat-dialog-close]="data.name" cdkFocusInitial>Ok</button>
</div>